import React, {useEffect} from "react"
import {Route, Redirect, RouteComponentProps} from "react-router-dom"
import qs from "qs"

import {NestedRoute} from "@irati/utils/history/routing"

import AppContainer from "@irati/ui/src/AppContainer"

import Logout from "../../containers/Logout"
import Login from "../../containers/Login/Login"
import GlobalLogin from "../../containers/Login/GlobalLogin"
import LoadingResetPassword from "../../components/LoadingResetPassword/LoadingResetPassword"
import ForgotDomain from "../../containers/Login/ForgotDomain"
import CheckEmail from "../../components/CheckEmail"
import ManageAccounts from "../../components/ManageAccounts"
import LoginSamlIDP from "../../containers/Login/LoginSamlIDP"
import {REDIRECT_STORAGE_KEY} from "../../constants/login"
import OneTimePassword from "../../containers/OneTimePassword"

interface Props extends RouteComponentProps {}

interface QueryParams {
  redirectTo?: string
}
const Welcome: React.FC<Props> = ({match, location}) => {
  if (location.pathname === "/welcome/logout") {
    // <AppContainer /> wrapper is making infinite loops for logout route
    return <Route exact path="/welcome/logout" component={Logout} />
  }

  useEffect(() => {
    const query = qs.parse(window.location.search.replace("?", "")) as QueryParams
    const loginRedirection = query.redirectTo ? query.redirectTo : "/"
    if (loginRedirection) {
      sessionStorage.setItem(REDIRECT_STORAGE_KEY, loginRedirection)
    }
  }, [])
  return (
    <AppContainer>
      <Route exact path="/welcome" render={() => <Redirect to="/welcome/login" />} />
      <NestedRoute useGrid={false} noauth exact match={match.url} path="/login" title="Login" component={OneTimePassword} />
      <NestedRoute useGrid={false} noauth exact match={match.url} path="/login/password" title="Login" component={Login} />
      <NestedRoute
        useGrid={false}
        noauth
        match={match.url}
        path="/login/loading-reset-password"
        title="Loading..."
        component={LoadingResetPassword}
      />
      <NestedRoute useGrid={false} noauth exact match={match.url} path="/login/domain" title="Login" component={ForgotDomain} />
      <NestedRoute useGrid={false} noauth match={match.url} path="/login/check-email" title="Check Email" component={CheckEmail} />
      <NestedRoute useGrid={false} noauth exact match={match.url} path="/domain" title="Login" component={GlobalLogin} />
      <NestedRoute useGrid={false} noauth exact match={match.url} path="/accounts" title="Manage Accounts" component={ManageAccounts} />
      <NestedRoute useGrid={false} noauth exact match={match.url} path="/login/idp" title="Login" component={LoginSamlIDP} />
    </AppContainer>
  )
}

export default Welcome
